export default __webpack_public_path__ + "93ae2a56b2314b33df7345dc56e699ba.svg";